import { v4 as generateId } from 'uuid';
import { useRef } from 'react';

// create unique ID for HTML element
export const useId = (): string => {
  const idRef = useRef(generateId());

  return idRef.current;
};
